import React from "react";
import Slider from "react-slick";
import { Box, FlexContainer, FlexDiv, Button, Image } from "@/components/Atoms";
import { Typography } from "@/foundation/Typography/V1";
import theme from "@/foundation/Theme";
import styled from "styled-components";
import NextImage from "next/image";

function Symptoms(props) {
  const {
    healthDetailsData = [],
    isMobile = false,
    handleScrollToCallBackForm = () => {},
  } = props || {};
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    swipeToSlide: true,
    slidesToShow: healthDetailsData?.benefits?.benefits?.length,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 5,
          dots: true,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          dots: true,
          infinite: false,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 374,
        settings: {
          slidesToShow: 2,
          dots: true,
          infinite: false,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      {healthDetailsData?.benefits?.benefits?.length > 0 && (
        <RedDiv flexDirection={"column"}>
          {healthDetailsData?.benefits?.benefit_answer &&
            healthDetailsData?.benefits?.benefit_question && (
              <TopFlexDom alignItems={"center"}>
                <LHSDiv flexDirection={"column"}>
                  <Typography variant="heading2" color={theme.colors.shadeRed}>
                    {healthDetailsData?.benefits?.benefit_question}
                  </Typography>
                </LHSDiv>
                <RHSDiv>
                  <Answer
                    fontFamily={"var(--font-600)"}
                    variant="paragraph1"
                    color={theme.colors.gray_90}
                  >
                    {healthDetailsData?.benefits?.benefit_answer}
                  </Answer>
                </RHSDiv>
              </TopFlexDom>
            )}
          <FlexDom>
            <LHSDiv flexDirection={"column"}>
              <Typography
                fontFamily={"var(--font-700)"}
                variant="heading2"
                color={theme.colors.gray_70}
                lineHeight={"30px"}
              >
                {healthDetailsData?.benefits?.title}
              </Typography>
              {!isMobile && healthDetailsData?.benefits?.benefits_cta && (
                <FlexDiv mt={"14px"}>
                  <Button
                    variant={"primary"}
                    onClick={handleScrollToCallBackForm}
                    fontSize={"15px"}
                  >
                    {healthDetailsData?.benefits?.benefits_cta}
                  </Button>
                </FlexDiv>
              )}
            </LHSDiv>
            <RHSDiv>
              <Slider {...settings}>
                {healthDetailsData?.benefits?.benefits?.map((item, index) => {
                  return (
                    <Box key={index} px={"5px"}>
                      <FlexDiv
                        flexDirection={"column"}
                        alignItems="center"
                        justifyContent="center"
                      >
                        <IconRing mb={"20px"}>
                          <NextImage
                            src={item.icon}
                            alt={item.title}
                            fill={true}
                            style={{ objectFit: "cover" }}
                          />
                        </IconRing>
                        <Typography
                          variant="link1"
                          fontSize="14px"
                          href={
                            item.url?.endsWith("/") ? item.url : `${item.url}/`
                          }
                          target="_blank"
                          color={theme.colors.gray_100}
                          textAlign="center"
                        >
                          {item.title}
                        </Typography>
                      </FlexDiv>
                    </Box>
                  );
                })}
              </Slider>
            </RHSDiv>
          </FlexDom>
        </RedDiv>
      )}
    </>
  );
}

export default Symptoms;
const RedDiv = styled(FlexDiv)`
  background: ${theme.colors.linearGradRed};
  padding: 35px 0;
`;
const LHSDiv = styled(FlexDiv)`
  max-width: 250px;
  margin-right: 50px;
  @media only screen and (max-width: 992px) {
    max-width: 100%;
    margin-right: 0;
    margin-bottom: 25px;
    align-items: center;
    text-align: center;
  }
`;
const RHSDiv = styled(FlexDiv)`
  flex: 1;
  max-width: 100%;
  min-width: 1px;
  .slick-slider {
    width: 100%;
    .slick-dots {
      li {
        &.slick-active {
          button {
            &::before {
              background-color: ${theme.colors.dotsColor};
            }
          }
        }
        button {
          position: relative;
          &::before {
            background-color: rgba(92, 92, 110, 0.2);
            border-radius: 50%;
            height: 8px;
            width: 8px;
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            transition: all 0.3s ease-in-out;
          }
        }
      }
    }
  }
`;
const IconRing = styled(Box)`
  height: 78px;
  width: 78px;
  border-radius: 50%;
  background-color: ${theme.colors.shadeRed};
  overflow: hidden;
  position: relative;
  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
  @media only screen and (max-width: 767px) {
    height: 66px;
    width: 66px;
  }
`;
const FlexDom = styled(FlexContainer)`
  @media only screen and (max-width: 992px) {
    flex-direction: column;
  }
`;
const TopFlexDom = styled(FlexDom)`
  margin-bottom: 55px !important;
  @media only screen and (max-width: 992px) {
    flex-direction: column;
    text-align: center;
  }
`;
const Answer = styled(Typography)`
  padding-left: 20px;
  @media only screen and (max-width: 992px) {
    padding-left: 0;
  }
`;
